export default __webpack_public_path__ + "static/media/AmandaBaroni_04.f78be18f.jpg";